var map = {
	"./austronesia_boat_michael_su.jpg": 327,
	"./austronesia_lanyu_community_boat_celebrate.jpg": 328,
	"./bakumpai_barito.jpg": 329,
	"./barangayan_cagayan_river.jpg": 330,
	"./halmahera_pakata_tobelo.jpg": 331,
	"./hokulea_sailing.jpg": 332,
	"./karakoa.jpg": 333,
	"./madagascar_traditional_fishing_pirogue.jpg": 334,
	"./malanesia_boat_landscape.psd": 335,
	"./mantou_rock_sunset_latombe.jpg": 100,
	"./mantou_rock_sunset_latombe_overlayed.jpg": 336,
	"./melanesia_boat.jpg": 337,
	"./melanesia_boat_landscape.jpg": 338,
	"./old_man_tattoo_larskrutak.jpg": 339,
	"./polynesian_canoe_herb_cane.jpg": 340,
	"./southeastern_coastline_latombe.jpg": 341,
	"./tao_fishermen_1940_lanyu_airport.jpg": 342,
	"./tatara_latombe.jpg": 343,
	"./traditional_tao_boat.jpeg": 344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 326;